export default {"src":"/_next/static/media/facebook.51561cf7.svg","height":22,"width":22,"blurWidth":0,"blurHeight":0};